import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export const useCheckStock = (
  options?: UseMutationOptions<any, Error, void>
) => {
  return useMutation({
    ...options,
    mutationKey: ["checkStock"],
    mutationFn: async () => {
      return axiosInstance.post("/reports/check").then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa sprawdzanie stanów...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "check-stock",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      const result = data?.result;
      const errors = result?.errors || 0;
      const reservations = result?.reservations;
      const reservationErrors = reservations?.errors || 0;
      const messages = [
        errors
          ? `Sprawdzono produkty: ${result.checked}, z błędem: ${errors}.`
          : `Sprawdzono produkty: ${result?.checked || 0}.`,
        reservations?.created
          ? `Nowe rezerwacje w Subiekcie: ${reservations.created}.`
          : null,
        reservations?.cancelled
          ? `Zwolnione rezerwacje: ${reservations.cancelled}.`
          : null,
        reservationErrors
          ? `Rezerwacje z błędem: ${reservationErrors} - szczegóły w zamówieniach.`
          : null,
      ];
      Toast({
        message: messages.filter(Boolean).join(" "),
        type:
          errors || reservationErrors
            ? TOAST_TYPES_ENUM.ERROR
            : TOAST_TYPES_ENUM.SUCCESS,
        id: "check-stock",
      });
      queryClient.invalidateQueries({ queryKey: ["reportComponents"] });
      queryClient.invalidateQueries({ queryKey: ["orders"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      const errorMessage =
        error?.data?.message || "Błąd podczas sprawdzania stanów.";
      Toast({
        message: errorMessage,
        type: TOAST_TYPES_ENUM.ERROR,
        id: "check-stock",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useCheckStock;
